<div class="duplicate-offer-form">
  <h5 class="duplicate-offer-title">{{ 'swal_messages.duplicate_into_offer_title' | translate }}</h5>

  <!-- Mode selector -->
  <div class="mode-selector">
    <label class="mode-option" [class.active]="mode === 'campaign'" (click)="setMode('campaign')">
      <input type="radio" name="duplicateMode" [checked]="mode === 'campaign'" />
      <span class="mode-label">
        <i class="icon-bullhorn"></i>
        {{ 'swal_messages.duplicate_into_offer_mode_campaign' | translate }}
      </span>
    </label>
    <label class="mode-option" [class.active]="mode === 'custom'" (click)="setMode('custom')">
      <input type="radio" name="duplicateMode" [checked]="mode === 'custom'" />
      <span class="mode-label">
        <i class="icon-pencil"></i>
        {{ 'swal_messages.duplicate_into_offer_mode_custom' | translate }}
      </span>
    </label>
  </div>

  <!-- Campaign mode -->
  <div *ngIf="mode === 'campaign'" class="mode-content">
    <div class="mb-5 buscador d-block">
      <label class="form-label">{{ 'inputs.campaign' | translate }}</label>
      <div class="client-selector">
        <div class="main-selector-container">
          <div class="selector-container-supplier" [ngClass]="{ expanded: showCampaignDropdown }">
            <input type="text"
              [placeholder]="'swal_messages.duplicate_into_offer_select_campaign' | translate"
              (focus)="onCampaignFocus()"
              (blur)="onCampaignBlur()"
              (input)="searchCampaigns($event.target)"
              [value]="displayCampaignText"
            />
            <span class="icon-chevron-down arrow"></span>
          </div>
          <div class="options-container" *ngIf="showCampaignDropdown" [ngClass]="{ visible: showCampaignDropdown }">
            <div class="option-value" *ngFor="let campaign of filteredCampaigns"
              (mousedown)="selectCampaign(campaign)">
              <div>{{ campaign.supplier_name }} - {{ campaign.name }}
                <span *ngIf="getMinFee(campaign) as minFee" class="campaign-min-fee">{{ "inputs.from" | translate }} {{ minFee | number:'1.2-2' }}€/{{ "tables.month" | translate }}</span>
              </div>
            </div>
            <div class="option-value text-muted" *ngIf="filteredCampaigns.length === 0">
              {{ 'filter_templates.no_presets' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Custom offer mode -->
  <div *ngIf="mode === 'custom'" class="mode-content">
    <p class="custom-hint">{{ 'swal_messages.duplicate_into_offer_custom_fields' | translate }}</p>

    <!-- Fila 1: Duración + Tipo -->
    <div class="row">
      <div class="col-6 mb-3">
        <label class="form-label">{{ 'inputs.duration' | translate }}</label>
        <ng-select [(ngModel)]="offerFields.duration" [items]="durationOptions"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
          [notFoundText]="'tables.no_results' | translate" (change)="onDurationChange()">
          <ng-template ng-label-tmp let-item="item">
            {{ item }} {{ 'inputs.month' | translate }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item }} {{ 'inputs.month' | translate }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-6 mb-3">
        <label class="form-label">{{ 'inputs.type' | translate }}</label>
        <ng-select [(ngModel)]="offerFields.type" [items]="typeOptions"
          [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
          [notFoundText]="'tables.no_results' | translate">
          <ng-template ng-label-tmp let-item="item">
            {{ 'inputs.' + item | translate }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ 'inputs.' + item | translate }}
          </ng-template>
        </ng-select>
      </div>
    </div>
    <!-- Fila 2: Km anuales + Km totales -->
    <div class="row">
      <div class="col-6 mb-3">
        <label class="form-label">{{ 'inputs.yearly_kms' | translate }}</label>
        <div class="input-group">
          <input type="text" class="form-control" [(ngModel)]="offerFields.yearly_kms" (input)="onYearlyKmsChange()" placeholder="{{ 'inputs.yearly_kms' | translate }}" />
        </div>
      </div>
      <div class="col-6 mb-3">
        <label class="form-label">{{ 'inputs.total_kms' | translate }}</label>
        <div class="input-group">
          <input type="text" class="form-control" [(ngModel)]="offerFields.total_kms" (input)="onTotalKmsChange()" placeholder="{{ 'inputs.total_kms' | translate }}" />
        </div>
      </div>
    </div>
    <!-- Fila 3: Cuota mensual — 3x col-4 -->
    <div class="row">
      <div class="col-12">
        <label class="form-label">{{ 'inputs.monthly_fee' | translate }}</label>
      </div>
      <div class="col-4 mb-3">
        <div class="input-group">
          <div class="currencydiv">
            <input type="number" class="form-control" [(ngModel)]="offerFields.monthly_fee_base" min="0" step="0.01" (input)="onMonthlyFeeBaseChange()" placeholder="{{ 'inputs.monthly_fee_base' | translate }}" />
            <span> +</span>
          </div>
        </div>
        <label class="form-label text08">{{ 'inputs.base' | translate }}</label>
      </div>
      <div class="col-4 mb-3">
        <div class="input-group">
          <div class="currencydiv">
            <input type="number" class="form-control" [(ngModel)]="offerFields.monthly_fee_tax" min="0" step="0.01" (input)="onMonthlyFeeTaxChange()" placeholder="{{ 'inputs.monthly_fee_tax' | translate }}" />
            <span>=</span>
          </div>
        </div>
        <label class="form-label text08">{{ 'inputs.tax' | translate }}</label>
      </div>
      <div class="col-4 mb-3">
        <div class="input-group">
          <div class="currencydiv">
            <input type="number" class="form-control" [(ngModel)]="offerFields.monthly_fee_total" min="0" step="0.01" (input)="onMonthlyFeeTotalChange()" placeholder="{{ 'inputs.monthly_fee_total' | translate }}" />
            <span>EUR</span>
          </div>
        </div>
        <label class="form-label text08">{{ 'inputs.total' | translate }}</label>
      </div>
    </div>
    <div class="row linea"></div>
    <!-- Fila 4: Checkboxes (2 + 2) -->
    <div class="row mb-3">
      <div class="col-12">
        <label class="form-label">{{ 'inputs.include' | translate }}</label>
      </div>
      <div class="col-6">
        <div class="form-check require-action">
          <input class="form-check-input" type="checkbox" [(ngModel)]="offerFields.include_maintenance" />
          <label class="form-check-label">{{ 'inputs.maintance' | translate }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-check require-action">
          <input class="form-check-input" type="checkbox" [(ngModel)]="offerFields.include_insurance" />
          <label class="form-check-label">{{ 'inputs.insurance' | translate }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-check require-action">
          <input class="form-check-input" type="checkbox" [(ngModel)]="offerFields.include_tires" />
          <label class="form-check-label">{{ 'inputs.tires' | translate }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-check require-action">
          <input class="form-check-input" type="checkbox" [(ngModel)]="offerFields.include_replacement_vehicle" />
          <label class="form-check-label">{{ 'inputs.replacement_vehicle' | translate }}</label>
        </div>
      </div>
    </div>
    <div class="row linea"></div>
    <!-- Fila 5: Entrada + Anticipo -->
    <div class="row">
      <div class="col-6 mb-3">
        <label class="form-label">{{ 'inputs.initial_payment' | translate }}</label>
        <div class="input-group">
          <input type="number" class="form-control" [(ngModel)]="offerFields.initial_payment" min="0" step="0.01" placeholder="{{ 'inputs.initial_payment' | translate }}" />
        </div>
      </div>
      <div class="col-6 mb-3">
        <label class="form-label">{{ 'inputs.prepayment' | translate }}</label>
        <div class="input-group">
          <input type="number" class="form-control" [(ngModel)]="offerFields.prepayment" min="0" step="0.01" placeholder="{{ 'inputs.prepayment' | translate }}" />
        </div>
      </div>
    </div>
    <!-- Fila 6: Transporte + Finanza -->
    <div class="row">
      <div class="col-6 mb-3">
        <label class="form-label">{{ 'inputs.transport' | translate }}</label>
        <div class="input-group">
          <input type="number" class="form-control" [(ngModel)]="offerFields.transport" min="0" step="0.01" placeholder="{{ 'inputs.transport' | translate }}" />
        </div>
      </div>
      <div class="col-6 mb-3">
        <label class="form-label">{{ 'inputs.deposit' | translate }}</label>
        <div class="input-group">
          <input type="number" class="form-control" [(ngModel)]="offerFields.deposit" min="0" step="0.01" placeholder="{{ 'inputs.deposit' | translate }}" />
        </div>
      </div>
    </div>
  </div>

</div>
